<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style src="./assets/styles/tailwind.css"></style>
<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2E2E2E;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #F5F5F5;
}
</style> 


// WEBPACK FOOTER //
// src/App.vue